<template>
  <div :class="[$style.wrapper, { [$style.deleteIndent]: this.$store.state.deleteIndent }]">
    <div :class="$style.container">
      <div v-if="this.$store.state.admin" :class="$style.add_card" @click="openAddCard">
        <img src="../assets/img/add.svg" alt="" />
      </div>

      <template v-if="!selectedObject || selectedObject">
        <template v-if="this.$store.state.admin">
          <Card
            v-for="object in objects"
            :key="object.id"
            :object="object"
            @click="openEditCard(object)"
          />
        </template>
        <template v-else-if="!this.$store.state.admin">
          <Card
            v-for="object in objects"
            :key="object.id"
            :object="object"
            :class="{ [$style.loading]: this.selectedObject?.id === object.id }"
            @openCard="openCard(object)"
          />
        </template>
      </template>
    </div>

    <OpenCard
      v-if="selectedObject && !this.$store.state.admin"
      :object="selectedObject"
      @deleteSelectedObject="
        () => {
          this.selectedObject = null;
        }
      "
    />
    <AddCard v-if="showAddCard" @backToCatalog="closeAddCard" />
    <EditCard
      v-if="this.$store.state.admin && showEditCard"
      :object="selectedObject"
      @backToCatalog="closeEditCard"
    />
  </div>
</template>

<script>
import Card from '../components/Card.vue';
import AddCard from '../components/AddCard.vue';
import EditCard from '../components/EditCard.vue';
import OpenCard from '../components/OpenCard.vue';

export default {
  components: { Card, AddCard, EditCard, OpenCard },
  props: {
    objects: Array,
  },
  data() {
    return {
      selectedObject: null,
      showAddCard: false,
      showEditCard: false,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const startappParam = urlParams.get('tgWebAppStartParam');

    if (startappParam) {
      const [action, id] = startappParam.split('_');

      if (action && id) {
        setTimeout(() => {
          for (const item of this.objects) {
            let object = {};

            if (item.id === id) {
              object = item;
              this.openCard(object);
            }
          }
        }, 500);
      }
    }
  },
  methods: {
    openCard(object) {
      this.triggerHapticFeedback();
      this.selectedObject = object;
      window.history.pushState({}, '', `/opencard/${object.id}`);
    },

    openAddCard() {
      this.triggerHapticFeedback();
      this.showAddCard = true;
    },
    closeAddCard() {
      this.showAddCard = false;
    },

    openEditCard(object) {
      this.triggerHapticFeedback();
      this.selectedObject = object;
      this.showEditCard = true;
    },
    closeEditCard() {
      this.showEditCard = false;
      this.selectedObject = null;
    },

    triggerHapticFeedback() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },
  },
};
</script>

<style lang="scss" module>
.loading {
  transition: all 0.35s ease;
  opacity: 0.2;
}

.wrapper {
  max-height: calc(75vh);
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.deleteIndent {
  max-height: calc(85vh);
}

.container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  margin: 0 0 50px 0;
}

.add_card {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 189px;
  width: 100%;
  border-radius: 16px;
  background-color: $bg-dark;
  grid-column: 1;
  transition: all 0.1s ease;

  img {
    transform: rotate(0);
    transition: all 0.08s ease;
  }

  &:hover {
    background: $background;
    transition: all 0.1s ease;
    img {
      transform: rotate(45deg);
      transition: all 0.08s ease;
    }
  }
}
</style>
